import { Component } from "@angular/core";
import { ViewController, NavParams } from 'ionic-angular';

@Component({
    templateUrl: "properties.popover.html"
})
export class PropertiesPopover {

    filters: any;
    sortChangeCallback: Function;    
    
    constructor(public viewCtrl: ViewController, private navParams: NavParams) { }

    ngOnInit() {

        if (this.navParams.data) {
            this.filters = this.navParams.data.filters;
            this.sortChangeCallback = this.navParams.data.sortChangeCallback;            
        }        
    }

    close() {

        this.viewCtrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/components/popovers/properties.popover.ts